// Telemetry keys for the multi-sensor (Sensor*) profiles arrive with two
// different device prefixes -- "VWP_WP_002_..." and "VWP-WR-05_..." -- because
// they were created at different times in ThingsBoard. The report has to show
// them in one shape: VWP-WP-<number>_<rest of the key>, i.e. WR is displayed as
// WP, the device part always uses hyphens and the number is padded to 3 digits
// so 05 and 011 line up as 005 and 011.
const DEVICE_PREFIX = /^VWP[\s_-]*W[PR][\s_-]*(\d+)[\s_-]*/i;

export const formatSensorKeyLabel = (key) => {
  if (typeof key !== "string") return key;
  return key.replace(
    DEVICE_PREFIX,
    (_match, number) => `VWP-WP-${number.padStart(3, "0")}_`
  );
};

export default formatSensorKeyLabel;
